import Flickity from 'flickity'
import 'flickity/css/flickity.css'
export function sliderPost () {
  const carruseles = document.querySelectorAll('.carrousel_post')
  if (carruseles) {
    carruseles.forEach(carr1 => {
      const flktyPOST = new Flickity(carr1, {
        cellAlign: 'center',
        contain: true,
        wrapAround: false,
        autoPlay: true,
        pauseAutoPlayOnHover: false,
        dragThreshold: 10,
        selectedAttraction: 0.2,
        friction: 0.8,
        pageDots: false

      })

      const rightBtn = document.querySelector('.next')
      const leftBtn = document.querySelector('.previous')
      if (rightBtn) {
        rightBtn.addEventListener('click', () => flktyPOST.next())
      }
      if (leftBtn) {
        leftBtn.addEventListener('click', () => flktyPOST.previous())
      }
    })
  }
}
sliderPost()
// import { sliderPost } from '@/js/templates/sliders/slider_post'
